import AbstractProvidedClass from "./AbstractProvidedClass";

export default class SpeciesCollection extends AbstractProvidedClass {
    collection = {};
    speciesElements = {};
    rows = {};

    init(collection = {}) {
        this.rowOptions = this.editMode
            ? ['info', 'plant', 'draw', 'add', 'addToSelection']
            : ['info'];
        this.collection = collection;
        Object.keys(this.collection).forEach((id) => {
            this.speciesElements[id] = [];
        });
        Object.entries(this.collection)
            .map(([id, species]) => {
                let row = this.provider.newPlantRow(species, this.rowContainer).only(this.rowOptions);
                row.hide();
                this.rows[id] = row;
            });
    }

    get(id) {
        return this.collection[id];
    }

    add(species) {
        this.collection[species.id] ||= species;
        this.speciesElements[species.id] ||= [];
        this.rows[species.id] ||= this.provider.newPlantRow(species, this.rowContainer).only(this.rowOptions);
        if (this.speciesElements[species.id].length == 0) {
            this.rows[species.id].hide();
        }
    }

    addObject(speciesId, object) {
        if (!this.speciesElements[speciesId].includes(object)) {
            this.speciesElements[speciesId].push(object);
        }
        this.rows[speciesId].show();
    }

    getObjects(speciesId) {
        return this.speciesElements[speciesId];
    }

    removeObject(speciesId, object) {
        this.speciesElements[speciesId] = this.speciesElements[speciesId].filter((o) => o != object);
        if (this.speciesElements[speciesId].length == 0) {
            this.rows[speciesId].hide();
        }
    }

    get rowContainer() {
        return this.sideBar.tabs['plants'].rowContainer;
    }
}
